import React, { useContext, useState } from "react";
import "./Sidebar.scss";
import logo from "../../assets/1x/matte_logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../../Context";
import { IoMdLogOut } from "react-icons/io";
import { api } from "../../api";
import { FaCircleArrowLeft } from "react-icons/fa6";
import { RiHome9Fill } from "react-icons/ri";
import { FaUser } from "react-icons/fa";
import { FaHouseUser } from "react-icons/fa";
import { PiFilmReelFill } from "react-icons/pi";
import { BsBoxes } from "react-icons/bs";
import { BsPeopleFill } from "react-icons/bs";

const Sidebar = () => {
  const location = useLocation();
  const { user, toggle, setToggle } = useContext(UserContext);
  const navigate = useNavigate();
  const [childIndex, setChildIndex] = useState();

  const navlinks = [
    {
      name: "Dashboard",
      path: "/",
      icon: <RiHome9Fill />,
    },
    ...(user?.role === "superadmin"
      ? [
          {
            name: "Add Users",
            path: "/addUsers",
            icon: <FaUser />,
          },
          {
            name: "Add New Seller",
            path: "/register",
            icon: <FaHouseUser />,
          },
        ]
      : []),

    {
      name: "Reel",
      icon: <PiFilmReelFill />,
      children: [
        {
          name: "Add Reel",
          path: "/addReel",
        },
        {
          name: "Reels",
          path: "/reels",
        },
      ],
    },
    {
      name: "Orders",
      
      icon: <BsBoxes />,
      children:[
        {
          name:"Full Orders",
          path:"/orders?today=today"
        },
        {
          name:"Deliverd Orders",
          path:"/DeliverdOrders"
        },
        {
          name:"Setteled Orders",
          path:"/setteldOrders"
        },
      ]
    },
    {
      name: "Sellers List",
      path: "/sellers",
      icon: <BsPeopleFill />,
    },
  ];

  const logout = async () => {
    try {
      const response = await api.post(`api/user/logout`);
      if (response.status === 200) {
        navigate("/login");
        window.location.reload();
      }
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className={toggle ? "sidebar-main" : "sidebar-main active"}>
        <div className="content">
          <div className="top_section">
            <div className="top">
              <img src={logo} alt="" />
              <div class="arrow" onClick={() => setToggle(!toggle)}>
                <FaCircleArrowLeft />
              </div>
            </div>
            <div className="links">
              {navlinks?.map((item, index) => (
                <Link
                  className={location.pathname === item.path ? "active" : ""}
                  to={item.path}
                  key={index}
                  onClick={() => setToggle(!toggle)}
                  onMouseEnter={() => {
                    setChildIndex(index);
                  }}
                >
                  <span>{item.icon}</span>

                  {item.name}

                  {item.children &&
                    childIndex === index &&
                    toggle !== false && (
                      <div
                        class="children"
                        onMouseLeave={() => setChildIndex()}
                      >
                        {item?.children?.map((item, index) => (
                          <Link  to={item.path} >{item.name}</Link>
                        ))}
                      </div>
                    )}
                </Link>
              ))}
            </div>
          </div>

          <div className="bottom">
            <h2>{user?.username}</h2>
            <span className="logout" onClick={logout}>
              <IoMdLogOut />
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
